<template>
  <div class="container">
    <!-- 左侧面板 -->
    <div class="left-panel">
      <div class="panel-header">产品新闻</div>
      <div v-for="(item, index) in leftNews" :key="index" class="news-item">
        <a :href="item.link">{{ item.title }}</a>
        <span class="date">{{ item.date }}</span>
      </div>
    </div>

    <!-- 右侧面板 -->
    <div class="right-panel">
      <!-- 行业报告 -->
      <div class="upper-section">
        <div class="panel-header2">行业报告</div>
        <div v-for="(item, index) in industryReports" :key="index" class="news-item2">
          <a :href="item.link">{{ item.title }}</a>
          <span class="date">{{ item.date }}</span>
        </div>
      </div>

      <!-- 精选文章 -->
      <div class="lower-section">
        <div class="panel-header3">精选文章</div>
        <div v-for="(item, index) in selectedArticles" :key="index" class="news-item3">
          <a :href="item.link">{{ item.title }}</a>
          <span class="date">{{ item.date }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      leftNews: [
        { title: "【Mail】谷歌邮箱国内能用吗？", date: "2024/11/20", link: "#" },
        { title: "【Mail】在中国用什么邮箱跟老外联系好", date: "2024/11/20", link: "#" },
        { title: "【Mail】外贸soho用什么邮箱好", date: "2024/11/19", link: "#" },
        { title: "【WorkDrive】什么是同步步？", date: "2024/11/20", link: "#" },
      ],
      industryReports: [
        { title: "2024年全球外贸行业趋势分析", date: "2024/11/19", link: "#" },
        { title: "最新电商平台发展报告", date: "2024/11/18", link: "#" },
      ],
      selectedArticles: [
        { title: "如何优化跨境电商销售", date: "2024/11/17", link: "#" },
        { title: "未来五年跨境电商趋势展望", date: "2024/11/16", link: "#" },
      ],
    };
  }
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.container {
  display: flex;
  justify-content: center;
  padding: 20px;
  background-color: white;
}

.left-panel, .right-panel {
  width: 25%; /* 保持宽度不变，可以根据需要调整 */
  margin: 0 30px;
}

.left-panel {
  background-color: rgb(250, 253, 254);
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 15px;
}

.right-panel {
  padding: 0 15px;
}

.panel-header {
  font-size: 18px;
  font-weight: bold;
  padding: 10px;
  color: white;
  border-radius: 4px;
  margin-bottom: 10px;
  position: relative;
  clip-path: polygon(0 0, 95% 0, 100% 100%, 0% 100%);
  text-align: center;
  width: 60%;
}

.panel-header2, .panel-header3 {
  font-size: 18px;
  font-weight: bold;
  padding: 10px;
  color: white;
  border-radius: 4px;
  margin-bottom: 10px;
  position: relative;
  clip-path: polygon(5% 0, 100% 0, 100% 100%, 0% 100%);
  text-align: center;
  width: 60%;
  margin-left: auto;
}

.left-panel .panel-header {
  background-color: rgb(29, 171, 224);
}

.right-panel .panel-header2 {
  background-color: #339216;
}

.right-panel .panel-header3 {
  background-color: rgb(227, 141, 30);
}

.upper-section, .lower-section {
  padding: 15px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.upper-section {
  background-color: #f5fff5;
}

.lower-section {
  background-color: rgb(255, 253, 247);
}

.news-item, .news-item2, .news-item3 {
  display: flex;
  justify-content: space-between;
  padding: 12px;
  border-bottom: 1px solid #e1e1e1;
}

.news-item:last-child,
.news-item2:last-child,
.news-item3:last-child {
  border-bottom: none;
}

.news-item a, .news-item2 a, .news-item3 a {
  text-decoration: none;
  color: #333;
}

.date {
  color: #888;
}

@media (max-width: 768px) {
  .container {
    flex-direction: column;
    align-items: center;
    padding: 10px;
  }

  .left-panel, .right-panel {
    width: 100%;
    margin: 0 0 20px 0;
  }

  .panel-header, .panel-header2, .panel-header3 {
    font-size: 20px; /* 放大标题 */
    width: 80%; /* 调整标题宽度 */
  }

  .news-item, .news-item2, .news-item3 {
    padding: 15px; /* 增大项的间距 */
  }

  .news-item a, .news-item2 a, .news-item3 a {
    font-size: 16px; /* 放大字体 */
  }

  .date {
    font-size: 14px; /* 放大日期字体 */
  }
}
</style>
